<template>
  <div class="container">
    <div class="weui-msg">
        <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">支付失败</h2>
            <p class="weui-msg__desc">信用卡付款失败，请确认信息正确并重新支付</p>
            <p class="weui-msg__desc" v-if="$route.query.errorMsg">{{$route.query.errorMsg}}</p>
        </div>
        <div class="btn-box">
          <div class="btn active" @click="payOrder()">重新支付</div><br>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-failed',
  methods: {
    payOrder(){
      history.replaceState(null, null, '/#/order');
      this.goto('/order-prepay?id='+this.$route.query.id);
    },
  },
  created: function () {
    if (localStorage.account_status) {
      this.account_status = localStorage.account_status;
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}

.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/order-error-cc.vue